
import React from "react";
import { 
  User, 
  CreditCard, 
  Globe, 
  Moon, 
  Truck, 
  Bell, 
  Lock,
  Globe2
} from "lucide-react";

// Type pour les éléments du menu
export type MenuItem = {
  id: string;
  icon: React.ReactNode;
  label: string;
  children?: { id: string; label: string; }[];
  isExpanded?: boolean;
};

// Items du menu
export const menuItems: MenuItem[] = [
  { 
    id: "profile", 
    icon: <User size={20} />, 
    label: "Profil"
  },
  { 
    id: "subscription", 
    icon: <CreditCard size={20} />, 
    label: "Abonnement Et Factures",
    isExpanded: true,
    children: [
      { id: "subscription-details", label: "Abonnement" },
      { id: "billing", label: "Factures" }
    ]
  },
  { 
    id: "language", 
    icon: <Globe size={20} />, 
    label: "Langue"
  },
  { 
    id: "appearance", 
    icon: <Moon size={20} />, 
    label: "Apparence"
  },
  { 
    id: "currency", 
    icon: <Globe2 size={20} />, 
    label: "Devises Et Marchés"
  },
  { 
    id: "domains", 
    icon: <Globe size={20} />, 
    label: "Noms De Domaines"
  },
  { 
    id: "shipping", 
    icon: <Truck size={20} />, 
    label: "Intégration De Livraison"
  },
  { 
    id: "notifications", 
    icon: <Bell size={20} />, 
    label: "Notifications"
  },
  { 
    id: "security", 
    icon: <Lock size={20} />, 
    label: "Sécurité"
  }
];
